import React, { lazy } from 'react';
import { ChevronLeft, ChevronRight, Check } from 'lucide-react';
interface Step2ThemeSelectProps {
  selectedTheme: string;
  onSelect: (theme: string) => void;
  onNext: () => void;
  onBack: () => void;
  angelName?: string;
}
interface ThemeOption {
  id: string;
  title: string;
  description: string;
  image: string;
}
export const Step2ThemeSelect: React.FC<Step2ThemeSelectProps> = ({
  selectedTheme,
  onSelect,
  onNext,
  onBack,
  angelName
}) => {
  const themeOptions: ThemeOption[] = [{
    id: 'lazy_morning',
    title: 'Lazy Morning',
    description: angelName ? `Wake up beside ${angelName} for a slow, intimate morning together` : 'Wake up beside your angel for a slow, intimate morning together',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vywW2JBc2YSPbuDa5RCbYQ/image.png'
  }, {
    id: 'hot_tub',
    title: 'Hot Tub Night',
    description: angelName ? `Join ${angelName} for a steamy evening in a private hot tub` : 'Join your angel for a steamy evening in a private hot tub',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/67ryciuuQw2CTDqb1piase/image.png'
  }, {
    id: 'club_seduction',
    title: 'Club Seduction',
    description: angelName ? `Meet ${angelName} at a nightclub for a night of dancing and seduction` : 'Meet your angel at a nightclub for a night of dancing and seduction',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8qPvBE4Ji5b8yvYDS1G6AY/image.png'
  }, {
    id: 'naughty_nurse',
    title: 'Naughty Nurse',
    description: angelName ? `${angelName} gives you a very thorough examination` : 'Your angel gives you a very thorough examination',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/77XczdQNc2nZQ4bXRw4L7E/image.png'
  }, {
    id: 'beach_day',
    title: 'Beach Day',
    description: angelName ? `Spend a day at a secluded beach with ${angelName}` : 'Spend a day at a secluded beach with your angel',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2CVTs42n8Fo9nseMS68YTa/image.png'
  }, {
    id: 'office_affair',
    title: 'Office Affair',
    description: angelName ? `${angelName} is your coworker, and you're working late together` : "Your angel is your coworker, and you're working late together",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png'
  }];
  return <div className="space-y-6" data-id="element-21920">
      <h2 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-21921">
        Choose Your Fantasy Theme
      </h2>
      <p className="text-gray-700 dark:text-gray-300" data-id="element-21922">
        Select a theme for your fantasy scenario. This will set the stage for
        your experience.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-21923">
        {themeOptions.map(theme => <div key={theme.id} className={`relative rounded-lg overflow-hidden border-2 cursor-pointer transition-all ${selectedTheme === theme.id ? 'border-pink-500 dark:border-pink-400 shadow-md shadow-pink-500/20' : 'border-gray-200 dark:border-gray-800 hover:border-pink-300 dark:hover:border-pink-800'}`} onClick={() => onSelect(theme.id)} data-id="element-21924">
            <div className="aspect-[4/3] w-full" data-id="element-21925">
              <img src={theme.image} alt={theme.title} className="w-full h-full object-cover" data-id="element-21926" />
            </div>
            <div className="p-3" data-id="element-21927">
              <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-21928">
                {theme.title}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-21929">
                {theme.description}
              </p>
            </div>
            {selectedTheme === theme.id && <div className="absolute top-2 right-2 w-6 h-6 bg-pink-500 rounded-full flex items-center justify-center" data-id="element-21930">
                <Check size={14} className="text-white" data-id="element-21931" />
              </div>}
          </div>)}
      </div>
      <div className="flex justify-between pt-4" data-id="element-21932">
        <button onClick={onBack} className="px-4 py-2 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors flex items-center" data-id="element-21933">
          <ChevronLeft size={16} className="mr-1" data-id="element-21934" />
          <span data-id="element-21935">Back</span>
        </button>
        <button onClick={onNext} className="px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-lg font-medium hover:from-pink-600 hover:to-purple-600 transition-all shadow-md shadow-pink-500/20 flex items-center" disabled={!selectedTheme} data-id="element-21936">
          <span data-id="element-21937">Continue</span>
          <ChevronRight size={16} className="ml-1" data-id="element-21938" />
        </button>
      </div>
    </div>;
};